import zhTW from '../../.octopus/zh-TW/index.js';

export default {
  TntdNewReference: zhTW,
};
